module.exports = __webpack_public_path__ + "img/b_19.5cdc8005.jpg";